import videojs from 'video.js';
import videojscontribads from 'videojs-contrib-ads';
import videojsima from 'videojs-ima';
import 'videojs-ima/dist/videojs.ima.css';
import './plugin.css';

const VERSION = '1.0.0';
const Plugin = videojs.getPlugin('plugin');
const Component = videojs.getComponent('Component');

const defaults = {
  duration: null,
  cuepoints: null,
  preroll_vast: null,
  midroll_vast: null,
};

class AdsGoogleVideoStitcher extends Plugin {

  constructor(player, options) {

    super(player);

    this.options = videojs.obj.merge(defaults, options);

    this.player.Simplestream().importer.url('https://imasdk.googleapis.com/js/sdkloader/ima3_dai.js').then(() => {
      this.init();
    })/*.catch(error => this.player.Simplestream().errorScreen('Please Disable AdBlocker'))*/;

  }

  init() { 

    this.buildUi();

    var streamsApiResponse = this.player.Simplestream().streamsApiResponse;
    var player = this.player;
    var videoElement = document.getElementsByTagName('video')[0];
    var clickElement = document.getElementById(this.player.id_ + '_adUi');

    var streamManager = new google.ima.dai.api.StreamManager(videoElement);
    streamManager.setClickElement(clickElement);
    streamManager.addEventListener([
        google.ima.dai.api.StreamEvent.Type.LOADED,
        google.ima.dai.api.StreamEvent.Type.ERROR,
        google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED,
        google.ima.dai.api.StreamEvent.Type.STARTED,
        google.ima.dai.api.StreamEvent.Type.FIRST_QUARTILE,
        google.ima.dai.api.StreamEvent.Type.MIDPOINT,
        google.ima.dai.api.StreamEvent.Type.THIRD_QUARTILE,
        google.ima.dai.api.StreamEvent.Type.COMPLETE,
        google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED
    ], (event) => {
      console.log('Google IMA DAI Event: ' + event.type, {
        'getStreamData': event.getStreamData(),
        'getAd': event.getAd(),
      });
      switch (event.type) {
        case 'loaded': 
          console.log("stream ready to start => " + event.getStreamData().url);
          console.log("DAI session: " + event.getStreamData().streamId);
          // listen to ID3 tags and pass them to IMA for ad tracking
          player.textTracks().on('addtrack', function (e) {
            // find out if the new track is metadata
            var track = e.track;
            if (track.kind === 'metadata') {
              // a cuechange event fires when the player crosses over an ID3 tag
              track.on('cuechange', function () {
                let elemTrack = track.activeCues[0];
                if (elemTrack && elemTrack.value.data) {
                  var metadata = {};
                  metadata[elemTrack.value.key] = elemTrack.value.data;
                  metadata["duration"] = Infinity;
                  streamManager.onTimedMetadata(metadata);
                }
              });
            }
          });
          
          var streamsApiResponse = this.player.Simplestream().streamsApiResponse;
          streamsApiResponse.stream = event.getStreamData().url;
          streamsApiResponse.ads.ssai = null;

          player.trigger('google-video-stitcher-ready', {
            streamsApiResponse: this.player.Simplestream().streamsApiResponse,
          });

        break;
        
        case 'error':
          console.log("Error => play fallback");

          var streamsApiResponse = this.player.Simplestream().streamsApiResponse;
          streamsApiResponse.stream = streamsApiResponse.stream;
          streamsApiResponse.ads.ssai = null;

          player.trigger('google-video-stitcher-ready', {
            streamsApiResponse: this.player.Simplestream().streamsApiResponse,
          });
        break;
        
      case 'adBreakStarted':
        console.log("ad break started => display ad ui element");
        clickElement.style.display = 'block';
      break;
      
      case 'adBreakEnded':
        console.log("ad break ended => hide ad ui element");
        clickElement.style.display = 'none';
      break;
      
      case 'started':
        console.log("ima event: " + event.type + " (" + event.getAd().getAdId() + ")");
      break;
      
      default:
        console.log("ima event: " + event.type);
      break;
      }
    }, false);

    // Request Live Stream
    var streamRequest = new google.ima.dai.api.VideoStitcherLiveStreamRequest();
    streamRequest.projectNumber = streamsApiResponse.ads.ssai.projectNumber;
    streamRequest.customAssetKey = streamsApiResponse.ads.ssai.customAssetKey;
    streamRequest.format = 'hls';
    streamRequest.networkCode = streamsApiResponse.ads.ssai.networkCode;
    streamRequest.liveStreamEventId = streamsApiResponse.ads.ssai.liveStreamEventId;
    streamRequest.region = streamsApiResponse.ads.ssai.region;
    streamRequest.oAuthToken = streamsApiResponse.ads.ssai.oAuthToken.access_token;
    streamRequest.adTagParameters = streamsApiResponse.ads.ssai.midrollAdTagParameters;
    streamManager.requestStream(streamRequest);

  }

  /**
   * Renders Ad UI
   */
  buildUi() {
    class adUi extends Component {
      constructor(player, options) {
        super(player, options);
        console.log('AdsGoogleVideoStitcher Ad UI');
      }
      createEl() {
        return videojs.dom.createEl('div', {
          className: 'vjs-ad-ui',
          id: this.player_.id_ + '_adUi',
          style: 'position: absolute; top: 0px; left: 0px; height: 100%; width: 100%; display: none;'
        });
      }
    };
    videojs.registerComponent('adUi', adUi);
    this.player.addChild('adUi', {});
  }
}

AdsGoogleVideoStitcher.defaultState = {};
AdsGoogleVideoStitcher.VERSION = VERSION;
videojs.registerPlugin('AdsGoogleVideoStitcher', AdsGoogleVideoStitcher);
export default AdsGoogleVideoStitcher;